module.exports = __webpack_public_path__ + "static/img/anxun21new2.aa28f343.png";